// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASE COLOR
------------------------------------------------------------*/
/* DISPLAY SETTING
------------------------------------------------------------*/
/* OTHER SETTING
------------------------------------------------------------*/
[data-v-a2cf8354]:root {
  font-size: clamp(13px + 2 * (100vw - 1440px) / 480, 1vw, 16px + 2 * (100vw - 1440px) / 480);
  --cx: 0;
  --cy: 0;
  --vw: 100vw;
  --vh: 100vh;
  --screen: 0px;
  --size: 32px;
}
@media screen and (min-width: 1920px) {
[data-v-a2cf8354]:root {
    font-size: 16px;
}
}
@media screen and (max-width: 1023px) {
[data-v-a2cf8354]:root {
    font-size: 14px;
    --size: 16px;
}
}
@media screen and (max-width: 769px) {
[data-v-a2cf8354]:root {
    font-size: 13.5px;
    --size: 10px;
}
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 100;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 200;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 300;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 400;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 500;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}
.slider-wrapper .main-swiper[data-v-a2cf8354] {
  width: 100%;
}
.slider-wrapper .main-swiper .swiper-slide[data-v-a2cf8354] {
  padding: 50% 0 0;
  position: relative;
  background: #f9fefb;
  border-radius: 0.4rem;
  overflow: hidden;
}
.slider-wrapper .main-swiper .swiper-slide img[data-v-a2cf8354] {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  position: absolute;
  top: 0;
  left: 0;
}
.slider-wrapper .thumbs-swiper[data-v-a2cf8354] {
  margin: 2.4rem 0 0;
}
.slider-wrapper .thumbs-swiper .swiper-slide[data-v-a2cf8354] {
  height: 8rem;
  border-radius: 0.4rem;
  overflow: hidden;
  position: relative;
  background: #f9fefb;
}
.slider-wrapper .thumbs-swiper img[data-v-a2cf8354] {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.slider-wrapper .thumbs-swiper .swiper-slide-thumb-active img[data-v-a2cf8354] {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/scss/module/_module.scss","webpack://./gallery.vue","webpack://./src/js/components/gallery.vue"],"names":[],"mappings":"AAEA;6DAAA;AAeA;6DAAA;AAOA;6DAAA;AAEA;EACC,2FAAA;EAKC,OAAA;EACD,OAAA;EACA,WAAA;EACA,WAAA;EACC,aAAA;EACA,YAAA;ACtBF;ADuBC;AAZD;IAaE,eAAA;ACpBA;AACF;ADqBC;AAfD;IAgBE,eAAA;IACE,YAAA;AClBF;AACF;ADmBC;AAnBD;IAoBE,iBAAA;IACE,YAAA;AChBF;AACF;AD0HA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,4BAAA;EACA,iBAAA;ACvHD;AC5DE;EACE,WAAA;AD8DJ;AC7DI;EACE,gBAAA;EACA,kBAAA;EACA,mBFDE;EEEF,qBAAA;EACA,gBAAA;AD+DN;AC9DM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ADgER;AC3DE;EACE,kBAAA;AD6DJ;AC5DI;EACE,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBFvBE;ACqFR;AC5DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AD8DN;AC5DI;EACE,UAAA;AD8DN","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
